import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/AboutUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/Academy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/academy/ClaudeCertification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/academy/RegisterInterest.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Blog"] */ "/opt/buildhome/repo/apps/web/src/components-pages/Blog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/Careers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/ClaudePartnerMalaysiaSingapore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/Company.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/Contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/CorporateMission.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/CorporateValues.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/enterprise/BrandPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/enterprise/DgxSparkEnquiry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/enterprise/DgxSparkMalaysia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/enterprise/DgxSparkModelPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/enterprise/DgxSparkTender.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/enterprise/EnterpriseEnquiry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/enterprise/EnterpriseHub.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/enterprise/NvidiaGpuEnquiry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/guides/AgentGpa.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/guides/ClaudeCowork.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/guides/ClaudeMalaysiaAccess.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/guides/ClaudePlansMalaysia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/guides/ClaudePrivacyCompliance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/Home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/IndustriesWeServe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/OurPartners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/partners/AdobePartner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/partners/AnthropicPartner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/partners/DellPartner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/Service.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/ServiceDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/AIAgentsAutomation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/AISolutions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/ClaudeManagedService.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/CloudArchitecture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/ConversationalAI.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/DigitalTransformation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/EnterpriseResilience.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/HardwareSoftware.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/ProductManagement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/SmartManufacturing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/SoftwareDevelopment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/SystemIntegration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/TrainingEducation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/VibeCodeRescue.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/WebsiteDevelopment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/AgentRescuePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/AgentUseCasesHub.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/BankReconciliationUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/CashApplicationUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/ContractReviewUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/CorporateCommsUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/CreditEvaluationUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/HrVerificationUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/IndustryLogistics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/IndustryRetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/InsuranceClaimsUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/InvoiceMatchingUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/KnowledgeAgentUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/KycOnboardingUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/LeaveManagementUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/OrderProcessingUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/ProductEnquiryUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/solutions/SupportTriageUseCase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/tools/AiVisibilityCheck.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/tools/ClaudeCostCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/ai-governance/DocPreviewModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/ai-governance/HubWaitlistForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/ai-governance/LitePackForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/ai-governance/OnThisPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/ai-governance/SectionInterestTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/ai-governance/TierCheck.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/ai-governance/TrackedGovLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/blog/ChatGPTPartnerCTA.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/blog/ClaudeBuyCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingPostNavigation"] */ "/opt/buildhome/repo/apps/web/src/components/blog/FloatingPostNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/blog/OpenAIPartnerCTA.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/blog/SonarPartnerCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ContentIdeaPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ImageTextSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/PageSchemas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ProcessSteps.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/common/StructuredData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/UniversalPageHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Budget2027GuideDownload"] */ "/opt/buildhome/repo/apps/web/src/components/guides/Budget2027GuideDownload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Budget2027Podcast"] */ "/opt/buildhome/repo/apps/web/src/components/guides/Budget2027Podcast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BudgetSlideFlipbook"] */ "/opt/buildhome/repo/apps/web/src/components/guides/BudgetSlideFlipbook.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatGPTPlanDownload"] */ "/opt/buildhome/repo/apps/web/src/components/guides/ChatGPTPlanDownload.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/guides/ClaudePlanDownload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhatsAppClaudeGuideDownload"] */ "/opt/buildhome/repo/apps/web/src/components/guides/GatedGuideDownload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntelligentUIStory","IntelligentUIExamples"] */ "/opt/buildhome/repo/apps/web/src/components/guides/IntelligentUIExperience.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/services/ConsultationCTA.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/services/ServiceFaq.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/shared/EzyChatCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EzyChatWhatsAppCta"] */ "/opt/buildhome/repo/apps/web/src/components/shared/EzyChatWhatsAppCta.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/shared/ShareBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTAButton"] */ "/opt/buildhome/repo/apps/web/src/components/ui/cta-button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
